/* feela. 整体エルゴクッション SEAT 専用LP (feela-seat-v2)
   このファイルはこのページ専用。他ページ・他セクションのJSに影響を与えない。
   カスタム要素は customElements.get() で二重定義を防止（テーマエディタでの再読込対策）。 */
(function () {
  'use strict';

  if (!window.customElements) return;

  /* Paidy injects these two verified images after page/cart/advisor updates.
     Supply names only when missing; leave the vendor's existing alternatives alone. */
  if (!window.__fsvPaidyAltObserver) {
    function labelPaidyImages(root) {
      if (!root || !root.querySelectorAll) return;
      var images = root.matches && root.matches('img') ? [root] : [];
      images = images.concat(Array.from(root.querySelectorAll('img')));
      images.forEach(function (img) {
        if (img.hasAttribute('alt')) return;
        if (img.src === 'https://cdn.paidy.com/promotional-messaging/general/images/paidy-text-white-v3.svg') {
          img.alt = 'Paidy';
        } else if (img.src === 'https://cdn.paidy.com/promotional-messaging/general/images/info_white_v3.svg') {
          img.alt = 'あと払い（ペイディ）の支払い方法について';
        }
      });
    }
    labelPaidyImages(document);
    window.__fsvPaidyAltObserver = new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') labelPaidyImages(record.target);
        else record.addedNodes.forEach(labelPaidyImages);
      });
    });
    window.__fsvPaidyAltObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  }

  /* ---- 購入エリア：カラー×硬さ → variant 解決、価格・在庫・カート追加ボタンを更新 ---- */
  if (!customElements.get('feela-seat-purchase')) {
    class FeelaSeatPurchase extends HTMLElement {
      connectedCallback() {
        if (this.dataset.fsvInitialized === 'true') return;
        this.dataset.fsvInitialized = 'true';

        this.variants = JSON.parse(this.querySelector('[data-fsv-variants]').textContent);
        this.priceMap = JSON.parse(this.querySelector('[data-fsv-price-map]').textContent);
        this.inputs = Array.from(this.querySelectorAll('input[type="radio"]'));
        this.idInput = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('.product-form__submit');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
        this.priceEl = this.querySelector('[data-fsv-price]');
        this.stockEl = this.querySelector('[data-fsv-stock]');
        this.mediaEl = this.querySelector('[data-fsv-media]');
        this.summaryNameEl = this.querySelector('[data-fsv-summary-name]');
        this.summaryWeightEl = this.querySelector('[data-fsv-summary-weight]');
        this.summaryDescEl = this.querySelector('[data-fsv-summary-desc]');

        this.addToCartText = this.dataset.addToCartText || 'カートに入れる';
        this.soldOutText = this.dataset.soldOutText || '在庫切れ';

        this.inputs.forEach((input) => {
          input.addEventListener('change', () => this.onChange());
        });

        /* 2026-08-31: このLPはカラーをブラック（ベロア）固定。
           グレーのラジオはそもそも書き出していないので通常は起こらないが、
           戻る操作・bfcache復帰でフォームの状態が復元された場合にも、
           必ずブラックが選ばれている状態から始める。
           リスナーはこの要素につき1回だけ登録する（初期化ガードの内側にある）。 */
        this.normalizeColor();
        this.onPageShow = (event) => {
          if (event.persisted) this.normalizeColor();
          this.onChange();
        };
        window.addEventListener('pageshow', this.onPageShow);

        this.onChange();
      }

      disconnectedCallback() {
        if (this.onPageShow) window.removeEventListener('pageshow', this.onPageShow);
      }

      /* カラーのラジオを、必ず固定値（ブラックの実値）が選ばれた状態に戻す。
         実値は商品データ由来で、Liquidが data 属性に入れている。 */
      normalizeColor() {
        const optionName = this.dataset.fsvColorOption || 'カラー';
        const value = this.dataset.fsvColorValue || '';
        if (!value) return;
        this.inputs.forEach((input) => {
          if (input.dataset.optionName !== optionName) return;
          input.checked = input.value === value;
        });
      }

      currentSelection() {
        const selected = {};
        this.inputs.forEach((input) => {
          if (input.checked) selected[input.dataset.optionName] = input.value;
        });
        return selected;
      }

      findVariant(selected) {
        return this.variants.find((variant) =>
          Object.keys(selected).every((name) => variant.options[name] === selected[name])
        );
      }

      onChange() {
        const selected = this.currentSelection();
        const variant = this.findVariant(selected);
        if (!variant) return;

        if (this.idInput) this.idInput.value = variant.id;

        if (this.priceEl && this.priceMap[variant.id]) {
          this.priceEl.textContent = this.priceMap[variant.id];
        }

        if (this.mediaEl && variant.featured_image) {
          this.mediaEl.src = variant.featured_image;
        }

        const available = !!variant.available;
        if (this.stockEl) {
          this.stockEl.textContent = available ? '在庫あり' : '在庫切れ';
          this.stockEl.dataset.state = available ? 'in' : 'out';
        }

        if (this.submitButton) {
          var form = this.querySelector('product-form');
          this.submitButton.disabled = !available || window.__fsvCartUncertain === true || !!(form && form.dataset.fsvCartUncertain === 'true');
        }
        if (this.idInput) {
          this.idInput.disabled = !available;
        }
        if (this.submitButtonText) {
          this.submitButtonText.textContent = available ? this.addToCartText : this.soldOutText;
        }

        this.inputs.forEach((input) => {
          const wrapper = input.closest('.feela-seat-v2-purchase__option');
          if (!wrapper) return;
          const testSelection = Object.assign({}, selected);
          testSelection[input.dataset.optionName] = input.value;
          const testVariant = this.findVariant(testSelection);
          wrapper.dataset.unavailable = testVariant && !testVariant.available ? 'true' : 'false';
        });

        this.syncSummary(selected['硬さ'] || '');
      }

      /* 2026-08-29: 選択中の硬さサマリー。独立した選択状態は持たず、
         既存のonChange()で解決済みの硬さ文字列をそのまま受け取るだけ */
      syncSummary(hardnessValue) {
        var info = { name: 'ミディアム（標準）', weight: '45〜85kg目安', desc: 'ほどよく沈む、しっかりした座り心地。' };
        if (hardnessValue.indexOf('ソフト') !== -1) {
          info = { name: 'ソフト（柔らかめ）', weight: '35〜60kg目安', desc: 'ふんわり沈む、やさしい座り心地。' };
        } else if (hardnessValue.indexOf('ハード') !== -1) {
          info = { name: 'ハード（硬め）', weight: '75〜110kg目安', desc: '沈み込みを抑えた、安定感のある座り心地。' };
        }
        if (this.summaryNameEl) this.summaryNameEl.textContent = info.name;
        if (this.summaryWeightEl) this.summaryWeightEl.textContent = info.weight;
        if (this.summaryDescEl) this.summaryDescEl.textContent = info.desc;
      }
    }
    customElements.define('feela-seat-purchase', FeelaSeatPurchase);
  }

  /* ---- 固定CTA：FVのCTA／購入エリア／FAQのいずれかが見えている間は非表示 ---- */
  if (!customElements.get('feela-seat-sticky-cta')) {
    class FeelaSeatStickyCta extends HTMLElement {
      connectedCallback() {
        if (this.dataset.fsvInitialized === 'true') return;
        this.dataset.fsvInitialized = 'true';

        const targetSelector = this.dataset.target || '#feela-seat-v2-purchase';
        const hideSelectors = this.dataset.hideSelectors || targetSelector;
        const hideTargets = Array.from(document.querySelectorAll(hideSelectors));
        const button = this.querySelector('button');
        const prefersReducedMotion =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (button) {
          button.addEventListener('click', () => {
            /* 2026-09-04: data-fsv-modal-open が付いている場合は、
               同じclickで別途動く硬さ比較モーダルの起動（document側の共通リスナー）に任せ、
               ここでのスクロールは行わない（両方同時に動くと紛らわしいため）。 */
            if (button.hasAttribute('data-fsv-modal-open')) return;
            const el = document.querySelector(targetSelector);
            if (el) {
              el.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
            }
          });
        }

        const intersecting = new Set();
        this.forceHidden = false;
        const updateVisibility = () => {
          this.dataset.visible = !this.forceHidden && intersecting.size === 0 ? 'true' : 'false';
        };
        this.setForceHidden = (hidden) => {
          this.forceHidden = hidden;
          updateVisibility();
        };

        if (!hideTargets.length || !('IntersectionObserver' in window)) {
          updateVisibility();
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                intersecting.add(entry.target);
              } else {
                intersecting.delete(entry.target);
              }
            });
            updateVisibility();
          },
          { threshold: 0 }
        );
        hideTargets.forEach((el) => observer.observe(el));
      }
    }
    customElements.define('feela-seat-sticky-cta', FeelaSeatStickyCta);
  }
})();

/* =====================================================================
   登場演出・順次強調などのモーション処理は feela-seat-v2-motion.js に分離した
   （2026-08-29。旧「モバイル向けエフェクト第1段階」を全画面幅対応の基盤v2へ統合）。
   このファイルには商品選択・固定CTA・モーダル・ライトボックスのロジックだけを残す。
   ===================================================================== */

/* =====================================================================
   硬さ比較モーダル ＋ 画像ライトボックス（全画面幅で有効）
   - フォーカストラップ / Escape / 背景クリックで閉じる
   - 閉じた後は開いたボタンへフォーカスを戻す
   - 表示中は背景スクロールを固定
   - 「◯◯を選ぶ」は購入エリアの該当optionへchangeを流して反映
   ===================================================================== */
(function () {
  'use strict';

  if (window.__fsvModalInitialized) return;
  window.__fsvModalInitialized = true;

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var openerElement = null;
  var scrollLockCount = 0;
  var stickyCta = document.querySelector('feela-seat-sticky-cta');

  function setStickyForceHidden(hidden) {
    if (stickyCta && typeof stickyCta.setForceHidden === 'function') {
      stickyCta.setForceHidden(hidden);
    }
  }

  /* fsv-overlay-open は「モーダル／ライトボックス表示中は背景の継続アニメーションを停止する」ための
     目印クラス（feela-seat-v2.css のモーション基盤v2が参照）。スクロールロックと同じ寿命で付け外す。 */
  function lockScroll() {
    scrollLockCount++;
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('fsv-overlay-open');
  }

  function unlockScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) {
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('fsv-overlay-open');
    }
  }

  function focusableIn(container) {
    return Array.from(
      container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }

  function trapFocus(container, event) {
    var items = focusableIn(container);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ---- 硬さ比較モーダル ---- */
  var modal = document.querySelector('[data-fsv-modal]');

  /* 沈み込み比較アニメーションの再生（2026-08-31）
     表示中のパネル内にあるSMILのanimate要素を先頭から1回だけ流す。
     ・reduced motion のときは何もしない（SVGのbase値が最終状態なのでそのまま完成形が出る）
     ・JSが無効でも同じ理由で最終状態が静止表示される
     ・ループも遅延監視もしない。scroll/resizeリスナーもIntersectionObserverも追加していない */
  function playSinkAnimation() {
    if (!modal || prefersReducedMotion) return;
    var panel = modal.querySelector('[data-fsv-panel]:not([hidden])');
    if (!panel) return;
    panel.querySelectorAll('[data-fsv-sink]').forEach(function (anim) {
      if (typeof anim.beginElement === 'function') {
        try {
          anim.beginElement();
        } catch (e) {
          /* SMIL非対応の環境では何もしない（base値の最終状態がそのまま出る） */
        }
      }
    });
  }

  /* =====================================================================
     モーダルCTA：硬さを購入エリアへ反映 → 既存の商品フォームでカート追加 → カートページへ
     （2026-08-31）
     設計の前提：
     ・variant IDマップも /cart/add.js の呼び出しも新しく作らない。
       variantの解決は購入エリア <feela-seat-purchase> の既存メソッド
       （currentSelection / findVariant）をそのまま呼ぶ。
       カート追加は既存の <product-form> を submit するだけで、実際の通信は
       テーマ標準の product-form.js が行う。
     ・このフォームには数量欄が無いため、Shopify既定の「数量1」で追加される。
     ・成否の判定もテーマ標準のcartイベント（cart-update / cart-error）を購読するだけ。
     ===================================================================== */
  var cartBusy = false;
  var CART_TIMEOUT_MS = 12000;
  var SOLD_OUT_TEXT = 'この硬さは現在在庫切れです';
  var CART_FAIL_TEXT = 'カートに追加できませんでした。時間をおいて、もう一度お試しください。';

  function purchaseEl() {
    return document.querySelector('feela-seat-purchase');
  }

  function productFormEl() {
    return document.querySelector('product-form');
  }

  /* 2026-08-31: このLPではカラーをブラック（ベロア）固定にした。
     実値（フォーム内部で使う商品オプションの値）と表示用ラベルは、購入エリアが
     持っている data 属性が唯一の出どころ。JS側で文字列を持たない。 */
  function fixedColorValue() {
    var purchase = purchaseEl();
    return purchase ? purchase.dataset.fsvColorValue || '' : '';
  }

  function fixedColorLabel() {
    var purchase = purchaseEl();
    return purchase ? purchase.dataset.fsvColorLabel || '' : '';
  }

  function colorOptionName() {
    var purchase = purchaseEl();
    return (purchase && purchase.dataset.fsvColorOption) || 'カラー';
  }

  /* カラーのラジオを、必ずブラックの実値が選ばれている状態にする。
     変更が必要だったときだけ change を発火する（無駄な再計算を起こさない）。 */
  function forceFixedColor() {
    var purchase = purchaseEl();
    var value = fixedColorValue();
    if (!purchase || !value) return false;
    var input = Array.from(purchase.querySelectorAll('input[type="radio"]')).filter(function (radio) {
      return radio.dataset.optionName === colorOptionName() && radio.value === value;
    })[0];
    if (!input) return false;
    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  function hardnessInputFor(keyword) {
    var purchase = purchaseEl();
    if (!purchase) return null;
    return Array.from(purchase.querySelectorAll('input[type="radio"]')).filter(function (radio) {
      return radio.dataset.optionName === '硬さ' && radio.value.indexOf(keyword) !== -1;
    })[0];
  }

  /* 現在のカラー × 指定した硬さ のvariantを、購入エリアの既存ロジックだけで解決する。
     選択状態そのものは書き換えないので、これを呼んでもvariantは変わらない。 */
  function variantFor(keyword) {
    var purchase = purchaseEl();
    if (!purchase || typeof purchase.findVariant !== 'function') return null;
    if (typeof purchase.currentSelection !== 'function') return null;
    var input = hardnessInputFor(keyword);
    if (!input) return null;
    var selection = purchase.currentSelection();
    selection['硬さ'] = input.value;
    return purchase.findVariant(selection) || null;
  }

  function hardnessKeywordForTab(key) {
    if (key === 'soft') return 'ソフト';
    if (key === 'hard') return 'ハード';
    return 'ミディアム';
  }

  function currentHardnessTab() {
    var current = document.querySelector(
      'feela-seat-purchase input[type="radio"][data-option-name="硬さ"]:checked'
    );
    if (!current) return 'medium';
    if (current.value.indexOf('ソフト') !== -1) return 'soft';
    if (current.value.indexOf('ハード') !== -1) return 'hard';
    return 'medium';
  }

  function syncPurchaseHardness(key) {
    var input = hardnessInputFor(hardnessKeywordForTab(key));
    if (!input || input.checked) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* AI硬さ診断の判定・文言・variant解決には触れず、ユーザーが診断結果の硬さを
     確定した瞬間だけ、既存購入エリアの硬さ選択へ反映する。これにより、その後
     sticky CTA等から比較モーダルを開いても、診断で選んだ硬さを引き継げる。 */
  function syncAdvisorHardnessFromClick(target) {
    if (!target || !target.closest) return;
    var advisor = target.closest('#flAdvInlineRoot');
    if (!advisor) return;

    var choice = target.closest('.fl-adv-opt-btn--primary, .fl-adv-tier-card');
    if (!choice || !advisor.contains(choice)) return;

    var label = choice.textContent || '';
    if (label.indexOf('ソフト') !== -1) syncPurchaseHardness('soft');
    else if (label.indexOf('ハード') !== -1) syncPurchaseHardness('hard');
    else if (label.indexOf('ミディアム') !== -1) syncPurchaseHardness('medium');
  }

  function refreshModalPurchase() {
    if (!modal) return;
    var purchase = purchaseEl();
    var purchaseArea = modal.querySelector('[data-fsv-modal-purchase]');
    var activeTab = modal.querySelector('[data-fsv-tab][aria-selected="true"]');
    var key = activeTab ? activeTab.dataset.fsvTab : currentHardnessTab();
    var keyword = hardnessKeywordForTab(key);
    var hardnessName = modal.querySelector('[data-fsv-modal-hardness]');
    var colorName = modal.querySelector('[data-fsv-modal-color-name]');
    var price = modal.querySelector('[data-fsv-modal-price]');
    var stock = modal.querySelector('[data-fsv-modal-stock]');
    var cta = modal.querySelector('[data-fsv-select-hardness]');
    var notice = modal.querySelector('[data-fsv-modal-notice]');
    var variant = null;

    if (purchase && typeof purchase.currentSelection === 'function' && typeof purchase.findVariant === 'function') {
      variant = purchase.findVariant(purchase.currentSelection()) || null;
    }

    var priceText = '';
    if (variant && purchase && purchase.priceMap) {
      priceText = purchase.priceMap[variant.id] || '';
    }
    if (!priceText && purchase) {
      var purchasePrice = purchase.querySelector('[data-fsv-price]');
      priceText = purchasePrice ? purchasePrice.textContent.trim() : '';
    }

    var stockSource = purchase ? purchase.querySelector('[data-fsv-stock]') : null;
    var available = !!(variant && variant.available);
    var productForm = productFormEl();
    var uncertain = window.__fsvCartUncertain === true || !!(productForm && productForm.dataset.fsvCartUncertain === 'true');
    var formError = productForm ? productForm.querySelector('.product-form__error-message') : null;
    var ctaLabel = keyword + 'をカートに追加';

    if (hardnessName) hardnessName.textContent = activeTab ? activeTab.textContent.trim() : keyword;
    if (colorName) colorName.textContent = fixedColorLabel();
    if (price) price.textContent = priceText;
    if (stock) {
      stock.textContent = stockSource ? stockSource.textContent.trim() : available ? '在庫あり' : '在庫切れ';
      stock.dataset.state = stockSource ? stockSource.dataset.state || (available ? 'in' : 'out') : available ? 'in' : 'out';
    }
    if (purchaseArea) purchaseArea.dataset.fsvVariantId = variant ? String(variant.id) : '';
    if (cta) {
      cta.dataset.fsvSelectHardness = keyword;
      cta.dataset.fsvCtaLabel = ctaLabel;
      cta.disabled = !available || uncertain;
      cta.textContent = available ? ctaLabel : '在庫切れ';
    }
    setModalNotice(notice, uncertain ? (formError && (formError.dataset.fsvErrorText || formError.textContent)) || '追加結果を確認できませんでした。カートの内容をご確認ください。' : available ? '' : SOLD_OUT_TEXT, uncertain);
  }

  document.addEventListener('fsv:cart-uncertain', refreshModalPurchase);
  window.addEventListener('pageshow', function () {
    if (window.__fsvCartUncertain === true) refreshModalPurchase();
  });

  function setModalNotice(notice, message, uncertain) {
    if (!notice) return;
    notice.textContent = message;
    if (uncertain) {
      var cartLink = document.createElement('a');
      cartLink.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
      cartLink.textContent = 'カートの内容を確認する';
      cartLink.style.cssText = 'display:block;color:inherit;text-decoration:underline;padding:12px 0;';
      notice.appendChild(cartLink);
    }
  }

  /* 処理中はCTA・タブ・閉じるボタン・副ボタンをまとめて操作不能にする。
     連打しても add は1回だけ、処理中はモーダルも閉じない。 */
  function setCartBusy(busy, activeCta) {
    cartBusy = busy;
    if (!modal) return;
    modal.dataset.fsvBusy = busy ? 'true' : 'false';
    modal.querySelectorAll('[role="tab"], [data-fsv-modal-close]').forEach(function (el) {
      el.disabled = busy;
    });
    if (busy) {
      modal.querySelectorAll('[data-fsv-select-hardness]').forEach(function (cta) {
        cta.disabled = true;
        if (cta === activeCta) cta.textContent = 'カートに追加中…';
      });
    } else {
      /* 文言・disabled・在庫切れ表示を現在の状態から作り直す */
      refreshModalPurchase();
    }
  }

  function addHardnessToCart(cta) {
    var purchase = purchaseEl();
    var productForm = productFormEl();
    if (!purchase || !productForm || !productForm.form) return;
    if (window.__fsvCartUncertain === true || productForm.dataset.fsvCartUncertain === 'true') {
      refreshModalPurchase();
      return;
    }

    var notice = modal ? modal.querySelector('[data-fsv-modal-notice]') : null;

    /* 1) カラーを必ずブラックの実値にする（このLPからカートへ入るのは常にブラック）
       2) 押した硬さを既存の硬さラジオへ反映 → 3) 既存のchange処理を発火 */
    forceFixedColor();
    var input = hardnessInputFor(cta.dataset.fsvSelectHardness);
    if (!input) return;
    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* 4) 更新後の商品フォームから確定variant IDを取得 */
    var idInput = productForm.form.querySelector('[name="id"]');
    var variantId = idInput ? idInput.value : '';

    /* 5) 在庫を再確認。購入エリアが解決した結果だけを見る（CTAは事前にdisabledにしてあるので
       ここへ来るのは想定外だが、念のための最終ゲート） */
    var stockEl = document.querySelector('[data-fsv-stock]');
    var soldOut =
      !variantId || !!(idInput && idInput.disabled) || !!(stockEl && stockEl.dataset.state === 'out');
    if (soldOut) {
      refreshModalPurchase();
      return;
    }

    /* 6) 既存の商品フォームをそのまま送信する。通信・エラー処理はテーマ標準の
       product-form.js に任せる。数量欄が無いのでShopify既定の1個。 */
    setCartBusy(true, cta);
    if (notice) notice.textContent = '';

    var settled = false;
    var unsubUpdate = null;
    var unsubError = null;
    var timer = null;
    var events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;

    function cleanup() {
      if (typeof unsubUpdate === 'function') unsubUpdate();
      if (typeof unsubError === 'function') unsubError();
      if (timer) clearTimeout(timer);
    }

    /* 失敗・結果不明のどちらでも、カートページへは移動せずモーダルも開いたままにする。
       自動での再送信はしない（同じ商品が二重に入る可能性があるため）。 */
    function fail() {
      if (settled) return;
      settled = true;
      cleanup();
      setCartBusy(false);
      var formError = productForm.querySelector('.product-form__error-message');
      setModalNotice(notice, formError && formError.textContent ? formError.dataset.fsvErrorText || formError.textContent : CART_FAIL_TEXT, window.__fsvCartUncertain === true || productForm.dataset.fsvCartUncertain === 'true');
    }

    function succeed() {
      if (settled) return;
      settled = true;
      cleanup();
      /* 7) 成功したときだけカートページへ。ドメインは決め打ちせずShopifyのルートを使う */
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location = root + 'cart';
    }

    if (events && typeof window.subscribe === 'function') {
      unsubUpdate = window.subscribe(events.cartUpdate, function (payload) {
        if (payload && payload.source === 'product-form') succeed();
      });
      unsubError = window.subscribe(events.cartError, function (payload) {
        if (payload && payload.source === 'product-form') fail();
      });
    }

    /* 通信そのものが落ちた場合、テーマ標準のproduct-form.jsはイベントを出さず
       consoleに記録するだけなので、その「結果不明」を拾うための保険 */
    timer = setTimeout(fail, CART_TIMEOUT_MS);

    if (typeof productForm.form.requestSubmit === 'function') {
      productForm.form.requestSubmit();
    } else {
      productForm.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  function openModal(opener) {
    if (!modal) return;
    openerElement = opener || null;
    modal.hidden = false;
    refreshModalPurchase();
    setStickyForceHidden(true);
    if (!prefersReducedMotion) {
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
    } else {
      modal.classList.add('is-open');
    }
    lockScroll();
    var modalBody = modal.querySelector('.feela-seat-v2-modal__body');
    if (modalBody) modalBody.scrollTop = 0;
    var firstTab = modal.querySelector('[role="tab"][aria-selected="true"]') || modal.querySelector('[role="tab"]');
    if (firstTab) firstTab.focus();
    playSinkAnimation();
  }

  /* options.restoreFocus === false のときだけ、開いたボタンへのフォーカス復帰を省く。
     「カラーを変更する」から閉じる場合に、購入エリアへフォーカスを渡すため。 */
  function closeModal(options) {
    if (!modal || modal.hidden) return;
    if (cartBusy) return; /* カート追加処理中は閉じない */
    var restoreFocus = !(options && options.restoreFocus === false);
    modal.classList.remove('is-open');
    var finish = function () {
      modal.hidden = true;
      unlockScroll();
      setStickyForceHidden(false);
      if (restoreFocus && openerElement) openerElement.focus();
      openerElement = null;
    };
    if (prefersReducedMotion) {
      finish();
    } else {
      setTimeout(finish, 220);
    }
  }

  function selectTab(key) {
    if (!modal) return;
    modal.querySelectorAll('[data-fsv-tab]').forEach(function (tab) {
      var selected = tab.dataset.fsvTab === key;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });
    modal.querySelectorAll('[data-fsv-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.fsvPanel !== key;
    });
    syncPurchaseHardness(key);
    refreshModalPurchase();
    playSinkAnimation();
  }

  document.addEventListener('click', function (event) {
    syncAdvisorHardnessFromClick(event.target);

    var openBtn = event.target.closest('[data-fsv-modal-open]');
    if (openBtn) {
      var requestedTab = openBtn.dataset.fsvModalTab || currentHardnessTab();
      selectTab(requestedTab);

      openModal(openBtn);
      return;
    }

    if (!modal || modal.hidden) return;

    /* カート追加処理中は暗幕クリックでも閉じない。
       ボタン類はdisabled済みなので、そもそもclickが発生しない。 */
    if (cartBusy) return;

    if (event.target.closest('[data-fsv-modal-close]')) {
      closeModal();
      return;
    }

    /* 暗幕は空divではなくコンテナ自身の背景のため、コンテナ自身（パネルの外側＝暗幕部分）を
       直接クリックした時だけ閉じる。パネル内をクリックした場合は event.target がその子要素になるため閉じない。 */
    if (event.target === modal) {
      closeModal();
      return;
    }

    var tab = event.target.closest('[data-fsv-tab]');
    if (tab && modal.contains(tab)) {
      selectTab(tab.dataset.fsvTab);
      return;
    }

    var selectBtn = event.target.closest('[data-fsv-select-hardness]');
    if (selectBtn && modal.contains(selectBtn)) {
      if (selectBtn.disabled) return;
      addHardnessToCart(selectBtn);
    }
  });

  if (modal) {
    modal.addEventListener('keydown', function (event) {
      /* カート追加処理中はEscapeでもタブ移動でも閉じない・切り替えない */
      if (cartBusy) {
        if (event.key === 'Escape') event.preventDefault();
        return;
      }
      if (event.key === 'Escape') {
        closeModal();
        return;
      }
      if (event.key === 'Tab') {
        trapFocus(modal.querySelector('.feela-seat-v2-modal__panel'), event);
        return;
      }
      var tab = event.target.closest && event.target.closest('[data-fsv-tab]');
      if (tab && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) {
        var tabs = Array.from(modal.querySelectorAll('[data-fsv-tab]'));
        var idx = tabs.indexOf(tab);
        var next = event.key === 'ArrowRight' ? (idx + 1) % tabs.length : (idx - 1 + tabs.length) % tabs.length;
        selectTab(tabs[next].dataset.fsvTab);
        tabs[next].focus();
        event.preventDefault();
      }
    });
  }

  /* ---- 画像ライトボックス（IGR認証書・試験資料） ---- */
  var lightbox = null;
  var lightboxOpener = null;

  function ensureLightbox() {
    if (lightbox) return lightbox;
    lightbox = document.createElement('div');
    lightbox.className = 'feela-seat-v2-lightbox';
    lightbox.hidden = true;
    lightbox.innerHTML =
      '<div class="feela-seat-v2-lightbox__panel" role="dialog" aria-modal="true" aria-label="画像の拡大表示">' +
      '<button type="button" class="feela-seat-v2-lightbox__close" data-fsv-lightbox-close aria-label="閉じる">&#10005;</button>' +
      '<img alt="">' +
      '</div>';
    document.body.appendChild(lightbox);

    var lightboxPanel = lightbox.querySelector('.feela-seat-v2-lightbox__panel');

    lightbox.addEventListener('click', function (event) {
      if (event.target.closest('[data-fsv-lightbox-close]')) {
        closeLightbox();
        return;
      }
      /* 暗幕は空divではなくコンテナ自身の背景のため、パネル自身（画像・閉じるボタン以外の余白＝暗幕部分）を
         クリックした時だけ閉じる。画像やボタンをクリックした場合は event.target がその子要素になるため閉じない。 */
      if (event.target === lightboxPanel) {
        closeLightbox();
      }
    });
    lightbox.addEventListener('keydown', function (event) {
      if (event.key === 'Tab') {
        event.preventDefault();
        lightbox.querySelector('[data-fsv-lightbox-close]').focus();
      }
    });
    /* Escapeはライトボックス要素だけで受けると、拡大画像をクリックしてフォーカスがbodyへ
       外れた時に効かなくなる。開いている間だけ効くようdocumentで受ける（登録は生成時の1回だけ） */
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!lightbox || lightbox.hidden) return;
      closeLightbox();
    });
    return lightbox;
  }

  function openLightbox(src, alt, opener) {
    var box = ensureLightbox();
    var img = box.querySelector('img');
    /* すでに開いている時に再度呼ばれても、スクロールロックと固定CTA制御は二重に掛けない。
       共通のロックカウンタは触らず、こちら側で1回に絞る（連打でoverflow:hiddenが残る不具合の対策） */
    var wasClosed = box.hidden;
    img.src = src;
    img.alt = alt || '';
    if (wasClosed) {
      lightboxOpener = opener || null;
      box.hidden = false;
      setStickyForceHidden(true);
      lockScroll();
    }
    if (prefersReducedMotion) {
      box.classList.add('is-open');
    } else {
      requestAnimationFrame(function () {
        box.classList.add('is-open');
      });
    }
    box.querySelector('[data-fsv-lightbox-close]').focus();
  }

  function closeLightbox() {
    if (!lightbox || lightbox.hidden) return;
    lightbox.classList.remove('is-open');
    var finish = function () {
      lightbox.hidden = true;
      unlockScroll();
      setStickyForceHidden(false);
      if (lightboxOpener) lightboxOpener.focus();
      lightboxOpener = null;
    };
    if (prefersReducedMotion) {
      finish();
    } else {
      setTimeout(finish, 220);
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-fsv-lightbox-open]');
    if (!btn) return;
    /* aタグで書かれている導線（JS無効時は正本画像へ直接移動できる）は、JSがある時だけ
       ページ内ライトボックスにする */
    if (btn.tagName === 'A') event.preventDefault();
    var innerImg = btn.querySelector('img');
    /* data-fsv-lightbox-alt があればそれを使う。サムネイル経由でもボタン経由でも同じaltになる */
    var alt = btn.dataset.fsvLightboxAlt || (innerImg ? innerImg.alt : '');
    openLightbox(btn.dataset.fsvLightboxOpen, alt, btn);
  });
})();

/* =====================================================================
   写真付き購入者レビュー：手動カルーセル（Astra Phase 2 / 2026-09-05）

   - 自動送り、操作後の自動再開、ループ用複製は行わない。
   - ネイティブ横スクロールによるスワイプと、左右ボタンだけで移動する。
   - レビュー原文は同じ要素内に保持し、4行プレビューから展開する。
   ===================================================================== */
(function () {
  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function initRoot(root) {
    if (root.dataset.fsvPrInitialized === 'true') return;

    var view = root.querySelector('[data-fsv-pr-view]');
    var list = root.querySelector('[data-fsv-pr-list]');
    var prev = root.querySelector('[data-fsv-pr-prev]');
    var next = root.querySelector('[data-fsv-pr-next]');
    var current = root.querySelector('[data-fsv-pr-current]');
    var total = root.querySelector('[data-fsv-pr-total]');
    if (!view || !list || !prev || !next) return;

    var items = Array.prototype.slice.call(list.querySelectorAll('[data-fsv-pr-item]'));
    if (!items.length) return;
    root.dataset.fsvPrInitialized = 'true';
    if (total) total.textContent = String(items.length);

    function gap() {
      var value = parseFloat(getComputedStyle(list).columnGap || getComputedStyle(list).gap);
      return isNaN(value) ? 0 : value;
    }

    function visibleCount() {
      var width = items[0].getBoundingClientRect().width + gap();
      return width ? Math.max(1, Math.floor((view.clientWidth + gap()) / width)) : 1;
    }

    function lastStart() {
      return Math.max(0, items.length - visibleCount());
    }

    function activeIndex() {
      var last = lastStart();
      var best = 0;
      var distance = Infinity;
      for (var i = 0; i <= last; i++) {
        var d = Math.abs(items[i].offsetLeft - list.offsetLeft - view.scrollLeft);
        if (d < distance) {
          best = i;
          distance = d;
        }
      }
      return best;
    }

    function fitViewportHeight(index) {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        view.style.height = '';
        return;
      }
      var item = items[index];
      if (!item) return;
      var styles = getComputedStyle(view);
      var extra = 0;
      if (styles.boxSizing === 'border-box') {
        extra += parseFloat(styles.paddingTop) || 0;
        extra += parseFloat(styles.paddingBottom) || 0;
        extra += parseFloat(styles.borderTopWidth) || 0;
        extra += parseFloat(styles.borderBottomWidth) || 0;
      }
      view.style.height = Math.ceil(item.getBoundingClientRect().height + extra) + 'px';
    }

    function updateControls() {
      var index = activeIndex();
      prev.disabled = index <= 0;
      next.disabled = index >= lastStart();
      if (current) current.textContent = String(index + 1);
      fitViewportHeight(index);
    }

    function move(step) {
      var index = Math.max(0, Math.min(lastStart(), activeIndex() + step));
      view.scrollTo({
        left: items[index].offsetLeft - list.offsetLeft,
        behavior: reduceMotion() ? 'auto' : 'smooth'
      });
    }

    /* Native overflow scrolling remains the primary mobile interaction.
       Some iOS/WebView combinations can report a swipe without advancing the
       horizontal scroller. In that case only, advance one card on pointer-up.
       No touchmove cancellation is used, so vertical page scrolling remains
       fully native. Tracking stays in the existing tracking asset. */
    var swipeFallback = null;

    function clearSwipeFallback() {
      swipeFallback = null;
    }

    view.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse') return;
      swipeFallback = {
        pointerId: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        scrollLeft: view.scrollLeft
      };
    }, { passive: true });

    view.addEventListener('pointerup', function (event) {
      if (!swipeFallback || event.pointerId !== swipeFallback.pointerId) return;

      var start = swipeFallback;
      clearSwipeFallback();

      var dx = event.clientX - start.x;
      var dy = event.clientY - start.y;
      var horizontalDistance = Math.abs(dx);
      var nativeScrollDistance = Math.abs(view.scrollLeft - start.scrollLeft);

      if (horizontalDistance < 35 || horizontalDistance <= Math.abs(dy) * 1.2) return;
      if (nativeScrollDistance >= 8) return;

      move(dx < 0 ? 1 : -1);
    }, { passive: true });

    view.addEventListener('pointercancel', clearSwipeFallback, { passive: true });

    function updateExpandable() {
      items.forEach(function (item) {
        var text = item.querySelector('[data-fsv-pr-text]');
        var button = item.querySelector('[data-fsv-pr-more]');
        if (!text || !button || item.classList.contains('is-expanded')) return;
        button.hidden = text.scrollHeight <= text.clientHeight + 1;
      });
    }

    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    view.addEventListener('scroll', updateControls, { passive: true });
    view.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      move(event.key === 'ArrowLeft' ? -1 : 1);
    });
    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-fsv-pr-more]');
      if (!button) return;
      var item = button.closest('[data-fsv-pr-item]');
      if (!item) return;
      var expanded = item.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.textContent = expanded ? '閉じる' : '続きを読む';
      updateControls();
    });
    window.addEventListener('resize', function () {
      updateControls();
      updateExpandable();
    }, { passive: true });

    updateExpandable();
    updateControls();
  }

  function scan() {
    document.querySelectorAll('[data-fsv-pr]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();

